// extracted by mini-css-extract-plugin
export default {"margin":"UserWallet_margin__6jQtk","menu":"UserWallet_menu__Uamgx","menuOption":"UserWallet_menuOption__oCKNx"};